<template lang="html">
  <!-- REFACTOR: Use v-overlay instead -->
  <v-dialog persistent :value="showDialog" width="400">
    <v-card color="primary" dark>
      <v-card-text>
        {{ $t('general.loading_message') }}
        <v-progress-linear
          indeterminate
          color="white"
          class="mb-0"
        ></v-progress-linear>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    delay: {
      type: Number,
      default: 250, // ms
    },
  },
  watch: {
    value: {
      immediate: true,
      handler(n) {
        if (this._delayedShowDialogTrigger != null) {
          clearTimeout(this._delayedShowDialogTrigger); // in case triggered again while timed out
        }

        if (n === false) {
          this.showDialog = n;
          return;
        }

        this._delayedShowDialogTrigger = setTimeout(() => {
          this.showDialog = n;
        }, this.delay);
      },
    },
  },
  data: () => ({
    showDialog: false,
    _delayedShowDialogTrigger: null, // watchers are fired separately, needs an external variable to keep track
  }),
};
</script>

<style lang="scss" scoped></style>
